import Icon from "@ant-design/icons";
const EmptyTableIconImg = () => (
  <>
    <img src={"/assets/images/empty-table.png"} alt=""/>
  </>
);

export const EmptyTableIcon = (props) => (
  <Icon component={EmptyTableIconImg} {...props} />
);
